import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../../util/theme';

const CtaBarFormBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  background-color: ${getColor('primaryBlue')};

  width: 100%;

  padding: 25px;

  position: relative;

  @media (min-width: ${getBreakpoint('lg')}) {
    flex-direction: row;

    padding: 25px 100px 50px 100px;
  }
`;

export default CtaBarFormBody;
